import { useMemo } from 'react';

import { useCarrierCodes } from './use-carrier-codes';

const SP_CARGO_TYPE = 'SP';

export type PackageTypeFilters = {
  carrierKey?: number;
  cargoTypeId?: string;
  searchParams?: { ids: string[] };
};

const isPackageTypeApiEnabled = (cargoTypeId?: string, carrierKey?: number) =>
  Boolean(carrierKey) && (!cargoTypeId || cargoTypeId === SP_CARGO_TYPE);

export const usePackageTypes = (defaultFilters: Partial<PackageTypeFilters> = {}) => {
  const { searchParams, cargoTypeId, carrierKey } = useMemo(() => defaultFilters, [defaultFilters]);
  const isEnabled = isPackageTypeApiEnabled(cargoTypeId, carrierKey);

  return useCarrierCodes({ carrierKey, searchParams }, { enabled: isEnabled });
};
